import { Fragment, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button, ButtonGroup, Col, Dropdown, Form, Row } from "react-bootstrap";
import { faCogs, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SafeDatatable } from "../../components/SafeDatatable";
//import ReactDatatable from "@ashvin27/react-datatable";

import { HeaderList } from "../../components/HeaderList";
import { CustomModal } from "../../components/Modal";

import { GroupService } from "../../services/group.service";
import { ToastService } from "../../services/toast.service";
import { ErrorHandler } from "../../services/errorHandler.service";

import { ResultRequestModel } from "../../models/resultRequest.model";
import { GroupModel } from "../../models/group.model";

import { useTranslation } from 'react-i18next';
import { RequestInputOutputParamsModel, RequestInputOutputParamsModelDefault } from "../../models/requestInputOutputParams.model";
import { DatasetDefault, DatasetModel } from "../../models/dataset.model";
import _ from 'lodash';
import { useHistory } from "react-router-dom";
import { ButtonSearch, ButtonClean } from "../../components/buttons";
import storageService from "../../services/storage.service";
import UtilService from "../../services/util.service";



const GroupList = () => {
  const user = storageService.getUser();
  const { pathname } = useLocation();
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const idiom = storageService.getIdiom();
  const [data, setData] = useState<DatasetModel>();
  const [showRemoveModal, setShowRemoveModal] = useState({
    id: 0,
    show: false,
    name: "",
    entity: null
  });
  const [dataset, setDataset] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)), dataset: 'group', filters: {
      fullname: [],
      nickname: []
    },
    sort: {
      field: 'fullName',
      orientation: 'asc'
    }
  });
  const history = useHistory();

  const columns = [
    {
      key: "fullName",
      text: t("GROUP.FULLNAME"),
      align: "left",
      sortable: true
    },
    {
      key: "nickName",
      text: t('GROUP.NICKNAME'),
      align: "left",
      sortable: true
    },
    {
      key: "action",
      text: t('ACTIONS'),
      className: "action",
      width: 100,
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            <Dropdown className='btn-toolbar'>
              <Dropdown.Toggle
                as={Button}
                variant='primary'
                size='sm'
                className='me-2'>
                <FontAwesomeIcon icon={faCogs} className='me-2' />
              </Dropdown.Toggle>
              { <Dropdown.Menu className='dashboard-dropdown dropdown-menu-left mt-2'>
                <Dropdown.Item
                  className='fw-bold'
                  onClick={() => history.push(`${pathname}/edit/${record.id}`)}>
                  <FontAwesomeIcon icon={faEdit} className='me-2' /> 
                  {(user.profile.profileName === "adm_reader"|| user.profile.profileName === "sys_admin") ? (
                        t("VIEW")
                      ):
                        t("EDIT")
                  }
                </Dropdown.Item>
                <Dropdown.Item
                  className='fw-bold'
                  onClick={() => actionRemove(record.id, record.fullName, record)}
                  disabled={user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"}
                  >
                  <FontAwesomeIcon icon={faTrash} className='me-2' /> {t('DELETE')}
                </Dropdown.Item>
              </Dropdown.Menu>}
            </Dropdown>
          </Fragment>
        );
      },
    },
  ];

  const getList = async (dataTable, datasetOverride = null) => {
    setLoading(true);

    let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [datasetOverride || dataset] };
    if (dataTable !== null && requestParams?.datasets) {
      let dataSet = requestParams.datasets[0];
      let pagination = dataSet.pagination;

      pagination.page_number = dataTable.page_number;
      pagination.records_pages = dataTable.page_size;
      dataSet.sort.field = dataTable.sort_order.column;
      dataSet.sort.orientation = dataTable.sort_order.order;
    }else{
      let pagination = requestParams.datasets[0].pagination;
      pagination.page_number = DatasetDefault.pagination.page_number;
      pagination.records_pages = DatasetDefault.pagination.records_pages;
    }

    let sort = requestParams.datasets[0].sort;
    if (!sort) {
        sort = requestParams.datasets[0].sort = {};
    }
    if (!sort.field || sort.field === null || sort.field.trim?.() === "") {
        sort.field = "fullName";
    }
    if (!sort.orientation || sort.orientation === null || sort.orientation.trim?.() === "") {
        sort.orientation = "asc";
    }

    const response: any = await  GroupService.getList(requestParams);

    if (response.success === true && response.result) {
      let d: DatasetModel = _.last(_.filter(response.result.datasets, { dataset: 'group' }));
      setData(d);
    } else {
      requestParams.datasets[0].data = null;
      setData(requestParams.datasets[0]);
    }
    setLoading(false);
  };

  const handleSearch = async (event) => {
    if (event != null)
      event.preventDefault();

    const trimfullname = dataset.filters.fullname?.[0]?.trim() || "";
    const trimnickname = dataset.filters.nickname?.[0]?.trim() || "";

    const cleanedDataset = {
      ...dataset,
      filters: {
        ...dataset.filters,
        fullname: [trimfullname],
        nickname: [trimnickname],
      },
    };

    await getList(null,cleanedDataset);
  };

  const tableChangeHandler = async (data) => {
    await getList(data);
  };

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  }

  const query = useQuery();

  const [flagClear, setFlagClear] = useState(false);

  useEffect(() => {
        if (flagClear)
        {
            handleSearch(null);
            setFlagClear(false);
        }
      }, [flagClear]);

  const handleClean = () => {
    setDataset({
      ...dataset, filters: {
        fullname: [],
        nickname: []
      },
      sort: {
        field: 'fullName',
        orientation: 'asc'
      }
    });
    setFlagClear(true);
  };

 const actionRemove = (id, name, entity) => {
    setShowRemoveModal({ id: id, show: true, name: name, entity });
  };

  const handleCloseModal = () =>
    setShowRemoveModal({ id: 0, show: false, name: "", entity: null });

  const remove = async () => {    
    if (showRemoveModal.id) {      
      try {
        const response: any = await GroupService.del(showRemoveModal.entity);        
        if (ErrorHandler.success(response)) {
          if (response.success) {
            ToastService.success(t('GROUP.REMOVED'));
            await getList(null);
            handleClean();
            handleCloseModal();
          }
        }
      } catch (error) { }
    }
  };


  const initialize = async () => {
    await getList(null);
  };

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
     <>
       <HeaderList path={`${pathname}/add`} title={t(`GROUP.TITLE_LIST`)} disabled={user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"} />

       <CustomModal
        Title={t('DELETE')}
        Message={`${t('GROUP.REMOVE_ANSWER')} ${showRemoveModal ? showRemoveModal.name : ""}?`}
        close={handleCloseModal}
        cancel={t('CANCEL')}
        show={showRemoveModal ? showRemoveModal.show : false}>
        <Button variant='primary' onClick={remove}>
          {t('YES')}
        </Button>
      </CustomModal>
      <Form>
      <Form.Label>{t('FILTERS')}</Form.Label>
      <Row>
        <Col sm={12} md={4} lg={3}>
          <Form.Group>
            <Form.Floating>
              <Form.Control
                name='fullname'
                id='fullname'
                type='text'
                placeholder={t('GROUP.FULLNAME')}
                className='form-control'
                onChange={(e) => {
                  setDataset({ ...dataset, filters: { ...dataset.filters, fullname: [e.target.value] } })
                }}
                value={dataset?.filters?.fullname.length > 0 ? dataset.filters.fullname[0] : ''}
              />
              <label htmlFor="fullname">{t("GROUP.FULLNAME")}</label>
            </Form.Floating>
          </Form.Group>
        </Col>

        <Col sm={12} md={3} lg={2}>
          <Form.Group>
            <Form.Floating>
              <Form.Control
                name='nickname'
                id='nickname'
                type='text'
                placeholder={t('GROUP.NICKNAME')}
                className='form-control'
                onChange={(e) => {
                  setDataset({ ...dataset, filters: { ...dataset.filters, nickname: [e.target.value] } })
                }}
                value={dataset?.filters?.nickname.length > 0 ? dataset.filters.nickname[0] : ''}
              />
              <label htmlFor="nickname">{t("GROUP.NICKNAME")}</label>
            </Form.Floating>
          </Form.Group>
        </Col>

        <Col xs="auto">
            <ButtonSearch onClick={handleSearch} />
          </Col>

          <Col xs="auto">
            <ButtonClean onClick={async (e) => {e.preventDefault(); handleClean();}} />
          </Col>
      </Row>
      

      <SafeDatatable
        key={flagClear ? "reset" : JSON.stringify(dataset.filters)}
        config={UtilService.verifyIdiomDataTable()}
        records={data?.data ? data?.data : []}
        columns={columns}
        dynamic={true}
        total_record={data?.pagination?.total_records ? data?.pagination?.total_records : 0}
        onChange={tableChangeHandler}
        className='table table-hover user-table align-items-center'
      />

      </Form> 
       
     </>
  );
};

export default GroupList;